/**
 * @generated SignedSource<<9a4f510d038133c2d4b30a41c598ea7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShareMeetingModalQuery$variables = {
  noteId: string;
};
export type ShareMeetingModalQuery$data = {
  readonly node: {
    readonly __typename: "Note";
    readonly " $fragmentSpreads": FragmentRefs<"ShareMeetingModal_note">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"BillingIdentityFeaturesPaywall_viewer" | "SendNotesModal_viewer">;
  };
};
export type ShareMeetingModalQuery = {
  response: ShareMeetingModalQuery$data;
  variables: ShareMeetingModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "noteId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v10 = [
  (v4/*: any*/),
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareMeetingModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SendNotesModal_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BillingIdentityFeaturesPaywall_viewer"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ShareMeetingModal_note"
              }
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShareMeetingModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "googleDocsConnected",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OfficeUserNode",
                "kind": "LinkedField",
                "name": "office365",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ZapierUserNode",
                "kind": "LinkedField",
                "name": "zapier",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNotePushHook",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesforceUserNode",
                "kind": "LinkedField",
                "name": "salesforce",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastUsedSalesforceInstanceType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enhancedNotesEnabled",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "HubspotUserNode",
                "kind": "LinkedField",
                "name": "hubspot",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GoogleUserNode",
                "kind": "LinkedField",
                "name": "google",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NotionUserNode",
                "kind": "LinkedField",
                "name": "notion",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ConfluenceUserNode",
                "kind": "LinkedField",
                "name": "confluence",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requiresReconnect",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubspotAccountNode",
                    "kind": "LinkedField",
                    "name": "hubspot",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userConnected",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ZoomBotNode",
                    "kind": "LinkedField",
                    "name": "zoomBot",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasAccessToHubspotFeature",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "hubspot_integration"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"hubspot_integration\")"
                  },
                  {
                    "alias": "hasAccessToSalesforceFeature",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "salesforce_integration"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"salesforce_integration\")"
                  },
                  {
                    "alias": "hasAccessToZapierIntegration",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "zapier_integration"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"zapier_integration\")"
                  },
                  {
                    "alias": "hasAccessToNotesIntegrationExport",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "notes_integration_export"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasAccessToFeature",
                    "storageKey": "hasAccessToFeature(feature:\"notes_integration_export\")"
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "featureAccess",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventStart",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventEnd",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasMeetingRecordings",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanEdit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStream",
                "kind": "LinkedField",
                "name": "stream",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AutomationConfigurationNode",
                    "kind": "LinkedField",
                    "name": "automationConfigurations",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AutomationNode",
                        "kind": "LinkedField",
                        "name": "automation",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "codeName",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "meetingRecapAutoShareSource",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": "sendTo_S",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sendTo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "setBy",
                            "plural": false,
                            "selections": (v10/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "StreamMeetingRecapAutoShareSettings",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": "sendTo_U",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sendTo",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": (v10/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "UserMeetingRecapAutoShareSettings",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v5/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingLink",
                "kind": "LinkedField",
                "name": "meetingRecordingLink",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visibility",
                    "storageKey": null
                  },
                  {
                    "alias": "urlForCopy",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "forCopy",
                        "value": true
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": "url(forCopy:true)"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allowPublicRecap",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "finished",
                "storageKey": null
              },
              {
                "alias": "noteTitle",
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "noteType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "version",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecording",
                "kind": "LinkedField",
                "name": "meetingRecordings",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingCallStart",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingCallEnd",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordedVideoDuration",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "eventTitle",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteUser",
                "kind": "LinkedField",
                "name": "noteuserSet",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "image",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isConfigured",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Channel",
                "kind": "LinkedField",
                "name": "postedInChannels",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isPrivate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "members",
                    "plural": true,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shortUrl",
                "storageKey": null
              }
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "11f4c20efae603f80a4698b2b40add6a",
    "id": null,
    "metadata": {},
    "name": "ShareMeetingModalQuery",
    "operationKind": "query",
    "text": "query ShareMeetingModalQuery(\n  $noteId: ID!\n) {\n  viewer {\n    ...SendNotesModal_viewer\n    ...BillingIdentityFeaturesPaywall_viewer\n    id\n  }\n  node(id: $noteId) {\n    __typename\n    ... on Note {\n      ...ShareMeetingModal_note\n    }\n    id\n  }\n}\n\nfragment BillingIdentityFeaturesPaywall_viewer on Viewer {\n  account {\n    billingAccount {\n      featureAccess\n      id\n    }\n    id\n  }\n}\n\nfragment SendNotesModal_IncludeAISummaryFormField_note on Note {\n  meetingRecordings {\n    ...utils_useLongestMeetingRecording_meetingRecordings\n    id\n  }\n}\n\nfragment SendNotesModal_Timing_note on Note {\n  eventStart\n  eventEnd\n  eventTitle\n  noteTitle: title\n}\n\nfragment SendNotesModal_note on Note {\n  id\n  eventStart\n  eventEnd\n  finished\n  noteTitle: title\n  noteType\n  version\n  meetingRecordings {\n    id\n  }\n  stream {\n    id\n    isExternal\n  }\n  ...SendNotesModal_IncludeAISummaryFormField_note\n  ...SendNotesModal_Timing_note\n}\n\nfragment SendNotesModal_viewer on Viewer {\n  user {\n    isGuest\n    id\n  }\n  googleDocsConnected\n  integrations {\n    office365 {\n      id\n    }\n    zapier {\n      isConnected\n      hasNotePushHook\n      id\n    }\n    salesforce {\n      id\n      isConnected\n      lastUsedSalesforceInstanceType\n      enhancedNotesEnabled\n    }\n    hubspot {\n      id\n      isConnected\n    }\n    google {\n      isActive\n      id\n    }\n    notion {\n      id\n      isConnected\n    }\n    confluence {\n      id\n      isConnected\n      requiresReconnect\n    }\n  }\n  account {\n    integrations {\n      hubspot {\n        userConnected\n        id\n      }\n      zoomBot {\n        isConnected\n        id\n      }\n    }\n    billingAccount {\n      hasAccessToHubspotFeature: hasAccessToFeature(feature: hubspot_integration)\n      hasAccessToSalesforceFeature: hasAccessToFeature(feature: salesforce_integration)\n      hasAccessToZapierIntegration: hasAccessToFeature(feature: zapier_integration)\n      hasAccessToNotesIntegrationExport: hasAccessToFeature(feature: notes_integration_export)\n      id\n    }\n    id\n  }\n}\n\nfragment ShareMeetingModal_note on Note {\n  id\n  title\n  createdAt\n  eventStart\n  eventEnd\n  hasMeetingRecordings\n  viewerCanEdit\n  stream {\n    id\n    type\n    ...hooksAutomations_useAnySendAutomationsEnabled_stream\n  }\n  meetingRecordingLink {\n    id\n    visibility\n  }\n  account {\n    __typename\n    allowPublicRecap\n    id\n  }\n  ...SendNotesModal_note\n  ...ShareMeetingModal_sharedWith\n  ...ShareMeetingModal_postedChannels\n  ...useCopyMeetingLink_note\n}\n\nfragment ShareMeetingModal_postedChannels on Note {\n  postedInChannels {\n    id\n    name\n    isPrivate\n    members {\n      id\n    }\n  }\n}\n\nfragment ShareMeetingModal_sharedWith on Note {\n  noteuserSet {\n    id\n    accessType\n    user {\n      id\n      email\n      fullName\n      image\n      isExternal\n      isGuest\n      isConfigured\n    }\n  }\n}\n\nfragment hooksAutomations_useAnySendAutomationsEnabled_stream on NoteStream {\n  id\n  automationConfigurations {\n    id\n    isActive\n    automation {\n      codeName\n      id\n    }\n  }\n  meetingRecapAutoShareSource {\n    __typename\n    ... on StreamMeetingRecapAutoShareSettings {\n      id\n      sendTo_S: sendTo\n      setBy {\n        id\n        fullName\n        firstName\n      }\n    }\n    ... on UserMeetingRecapAutoShareSettings {\n      id\n      sendTo_U: sendTo\n      user {\n        id\n        fullName\n        firstName\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useCopyMeetingLink_note on Note {\n  id\n  hasMeetingRecordings\n  meetingRecordingLink {\n    id\n    urlForCopy: url(forCopy: true)\n  }\n  shortUrl\n}\n\nfragment utils_useLongestMeetingRecording_meetingRecordings on MeetingRecording {\n  meetingCallStart\n  meetingCallEnd\n  meetingRecordedVideoDuration\n}\n"
  }
};
})();

(node as any).hash = "d306de7545352c22df3b896cde16b8c4";

export default node;
